import { useNavigate } from 'react-router-dom';
import { allNewsArticles } from '../../../mocks/allNews';

export default function NewsSection() {
  const navigate = useNavigate();
  const featured = allNewsArticles.find((n) => n.featured);
  const rest = allNewsArticles.filter((n) => !n.featured).slice(0, 3);

  return (
    <section id="news" className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-10 bg-[#C9A961]" />
              <span className="text-[#C9A961] text-xs font-bold uppercase tracking-widest">
                Tin Tức & Insights
              </span>
            </div>
            <h2 className="font-heading text-4xl md:text-5xl text-[#0D4D4D] font-semibold">
              Cập Nhật Thị Trường
            </h2>
          </div>
          <button onClick={() => navigate('/tin-tuc')} className="border-2 border-[#0D4D4D] text-[#0D4D4D] font-semibold px-6 py-3 rounded-full hover:bg-[#0D4D4D] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer self-start md:self-auto flex-shrink-0">
            Xem Tất Cả Bài Viết
          </button>
        </div>

        {/* Featured Post */}
        {featured && (
          <div onClick={() => navigate(`/tin-tuc/${featured.slug}`)} className="grid lg:grid-cols-[55%_45%] gap-0 rounded-3xl overflow-hidden mb-8 group cursor-pointer">
            <div className="relative overflow-hidden h-64 lg:h-auto">
              <img
                src={featured.image}
                alt={featured.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="bg-[#F8F9FA] p-10 flex flex-col justify-center">
              <span className="inline-block bg-[#C9A961] text-[#0D4D4D] text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full mb-5 self-start">
                {featured.category}
              </span>
              <h3 className="font-heading text-2xl md:text-3xl text-[#0D4D4D] font-semibold leading-snug mb-4 group-hover:text-[#155F5F] transition-colors">
                {featured.title}
              </h3>
              <p className="text-[#4A5568] text-base leading-relaxed mb-6 line-clamp-3">
                {featured.excerpt}
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 text-[#9CA3AF] text-sm">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {featured.date}
                  </span>
                  <span>·</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {featured.readTime}
                  </span>
                </div>
                <button className="flex items-center gap-1.5 text-[#C9A961] font-semibold text-sm hover:gap-2.5 transition-all cursor-pointer whitespace-nowrap">
                  Đọc Thêm
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          </div>
        )}

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {rest.map((article) => (
            <article
              key={article.id}
              onClick={() => navigate(`/tin-tuc/${article.slug}`)}
              className="group rounded-2xl overflow-hidden border border-[#E5E7EB] hover:border-[#C9A961] transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 bg-[#0D4D4D] text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full">
                  {article.category}
                </span>
              </div>
              <div className="p-6">
                <h3 className="text-[#0D4D4D] font-bold text-base leading-snug mb-3 line-clamp-2 group-hover:text-[#C9A961] transition-colors">
                  {article.title}
                </h3>
                <p className="text-[#6B7280] text-xs line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-[#6B7280] text-xs">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
